import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';

import { useTownAssets } from '../../stores';
import ConfirmPopup from '../display/ConfirmPopup';

import PicturePreview from './PicturePreview';

// Picking a file is not sending it: the picture is shown as it will arrive,
// with the turn and the note the sender wants, and leaves only on confirmation.
const SendPicturePopup = function SendPicturePopup(props) {
  const {
    file,
    onConfirm,
    onReject,
  } = props;
  const { assets } = useTownAssets();
  const { translate } = assets;
  const [rotation, setRotation] = useState(0);
  const [note, setNote] = useState('');

  const rotate = useCallback(
    () => {
      setRotation((current) => ((current + 90) % 360));
    },
    [],
  );

  const confirm = useCallback(
    () => {
      onConfirm({ file, rotation, note });
    },
    [onConfirm, file, rotation, note],
  );

  return (
    <ConfirmPopup
      name="sendPicture"
      title={translate('sendPictureDescr', 'chat')}
      yes={translate('send')}
      no={translate('cancel')}
      onConfirm={confirm}
      onReject={onReject}
      className="min-w-[380px]"
    >
      <PicturePreview
        file={file}
        rotation={rotation}
        onRotate={rotate}
        note={note}
        onNote={setNote}
      />
    </ConfirmPopup>
  );
};

SendPicturePopup.propTypes = {
  file: PropTypes.instanceOf(File).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
};

export default SendPicturePopup;
